import {
  Coordinate,
  MapContextMenuHandler,
  Polyline,
  Map as RousenMap,
  TileLayer,
} from "rousen-react";
import React, { useState, useCallback, useEffect, useRef } from "react";
import { Box, useTheme } from "@mui/material";
import Marker from "./Marker";
import MapMenu from "./MapMenu";
import { useGetRouteQuery } from "../apis/route";

const Map = () => {
  const [center] = useState<Coordinate>({ lon: 126.99586709219822, lat: 37.521023805105315 });
  const [zoom] = useState(13);
  const [menu, setMenu] = useState<{ x: number; y: number; coords: Coordinate } | null>(null);
  const [markers, setMarkers] = useState({
    origin: { lon: 126.92812392001953, lat: 37.492900396892566 },
    destination: { lat: 37.5383777, lon: 127.0802159 },
  });

  const onContextMenu: MapContextMenuHandler = useCallback((event, coords) => {
    setMenu({ x: event.x, y: event.y, coords });
  }, []);

  const onCloseMenu = useCallback(() => {
    setMenu(null);
  }, []);

  const [paths, setPaths] = useState<Coordinate[]>([]);

  const onChangeMarker = useCallback((type: "origin" | "destination", coords: Coordinate) => {
    setMarkers((prev) => ({ ...prev, [type]: coords }));
    setPaths([]);
  }, []);

  const theme = useTheme();

  const { data } = useGetRouteQuery(markers);

  const intervalRef = useRef<NodeJS.Timer>();

  useEffect(() => {
    if (!data) return undefined;
    const { coordinates } = data.points;
    let currentIndex = 0;
    const lastIndex = coordinates.length - 1;
    const speed = Math.floor(4000 / coordinates.length);

    intervalRef.current = setInterval(() => {
      if (currentIndex === lastIndex) {
        clearInterval(intervalRef.current);
        return;
      }

      const [lon, lat] = coordinates[currentIndex];
      setPaths((prev) => [...prev, { lon, lat }]);
      currentIndex += 1;
    }, speed);
    return () => {
      setPaths([]);
      clearInterval(intervalRef.current);
    };
  }, [data]);

  return (
    <Box height={500}>
      <RousenMap zoom={zoom} center={center} onContextMenu={onContextMenu}>
        <TileLayer
          crossOrigin="anonymous"
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          attributions='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'
        />
        <Marker color="primary" coordinate={markers.origin} />
        <Marker color="secondary" coordinate={markers.destination} />
        <Polyline paths={paths} style={{ color: theme.palette.info.main, width: 5 }} />
      </RousenMap>
      <MapMenu menu={menu} onClose={onCloseMenu} onChangeMarker={onChangeMarker} />
    </Box>
  );
};

export default Map;
